import { useAppSelector } from "@ch/redux-store/hooks/useAppSelector";
import moment from "moment";

const useUserDetails = () => {
  const userId = useAppSelector((state) => state.user.currentUser?.id);
  const email = useAppSelector((state) => state.user.currentUser?.email);
  const phone = useAppSelector((state) => state.user.currentUser?.phone);
  const firstName = useAppSelector(
    (state) => state.user.currentUser?.firstName,
  );
  const lastName = useAppSelector((state) => state.user.currentUser?.lastName);
  const name = useAppSelector((state) => state.user.currentUser?.name);
  const gender = useAppSelector((state) => state.user.currentUser?.gender);
  const dateOfBirth = useAppSelector((state) => state.user.currentUser?.dob);

  const age = dateOfBirth ? moment().diff(moment(dateOfBirth), "years") : null;

  const fullName = firstName && lastName ? `${firstName} ${lastName}` : name;

  return {
    userId,
    email,
    phone,
    firstName,
    lastName,
    fullName,
    gender,
    age,
  };
};

export default useUserDetails;
